import { render } from "./ConfirmDialog.vue?vue&type=template&id=221c627f"
import script from "./ConfirmDialog.vue?vue&type=script&lang=ref"
export * from "./ConfirmDialog.vue?vue&type=script&lang=ref"
script.render = render

export default script